/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * サーバーに保存されたPIXTA画像のデータ
 * @export
 * @interface PixtaStoredImage
 */
export interface PixtaStoredImage {
    /**
     * 画像幅(px)
     * @type {number}
     * @memberof PixtaStoredImage
     */
    width: number;
    /**
     * 画像高さ(px)
     * @type {number}
     * @memberof PixtaStoredImage
     */
    height: number;
    /**
     * サーバーに保存されたPIXTA画像のファイル名
     * @type {string}
     * @memberof PixtaStoredImage
     */
    fileName: string;
}

export function PixtaStoredImageFromJSON(json: any): PixtaStoredImage {
    return PixtaStoredImageFromJSONTyped(json, false);
}

export function PixtaStoredImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PixtaStoredImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'width': json['width'],
        'height': json['height'],
        'fileName': json['file_name'],
    };
}

export function PixtaStoredImageToJSON(value?: PixtaStoredImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'width': value.width,
        'height': value.height,
        'file_name': value.fileName,
    };
}

